import type { PageListParams } from '../api/pages-api';

/** Store-scoped keys: switching stores never shares cache. */
export const pageKeys = {
  all: (storeId: string) => ['stores', storeId, 'pages'] as const,
  lists: (storeId: string) => [...pageKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: PageListParams) => [...pageKeys.lists(storeId), params] as const,
  detail: (storeId: string, id: string) => [...pageKeys.all(storeId), 'detail', id] as const,
};
